import { createAction } from '@reduxjs/toolkit';

import { User } from '../../gql/graphql';

export const setUser = createAction<User | undefined>('user/setUser');
